import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.el.addEventListener('click', this.handleClick.bind(this));
        this.target = this.el.dataset.target;
        document.addEventListener('click', this.handleDocumentClick.bind(this));
    }

    handleClick(event) {
        let activeTooltips = document.querySelectorAll('.js-tooltip.is-active');
        event.stopPropagation(); // Prevent the document click handler from immediately closing the tooltip
        if (this.target) {
            const target = document.querySelector(this.target);
            target.classList.toggle('is-active');
        }
        activeTooltips.forEach(tooltip => {
            tooltip.classList.remove('is-active');
        });
    }

    handleDocumentClick(event) {
        if (this.target) {
            const target = document.querySelector(this.target);
            if (target && !target.contains(event.target) && !this.el.contains(event.target)) {
                target.classList.remove('is-active');
            }
        }
    }
}